<app-info-box *ngIf="discountValue" type="light">
  {{ 'payments.current_package.discount_info.value' | translate: { value: discountValue } }}
  <span *ngIf="discount.ends_at">{{ 'payments.current_package.discount_info.ends' | translate: { endsAt: discount.ends_at } }}</span>
</app-info-box>
